// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ka-0";
export var fulfillmentPanelBody = "_ka-1";